import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const SectionContainer = styled(Box)`
  background-color: ${COLORS.White};
  margin: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SectionHeader = styled(Box)`
  padding: 12px 16px;
  background-color: ${COLORS.NavyBlue};
  color: ${COLORS.White};
`;

export const SectionTitle = styled(Box)`
  font-size: 14px;
  font-weight: 600;
`;

export const SectionContent = styled(Box)`
  padding: 16px;
`;

export const InfoGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`;

export const InfoCell = styled(Box)`
  min-width: 0;
`;

export const InfoLabel = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 11px;
  color: ${COLORS.Gray};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const InfoValue = styled(Box)`
  font-size: 14px;
  color: ${COLORS.Black};
  word-break: break-word;
`;

export const FullWidthCell = styled(Box)`
  margin-bottom: 16px;
`;

export const FaultBlock = styled(Box)`
  padding: 12px;
  background-color: ${COLORS.LightYellow};
  border-radius: 8px;
  border-left: 3px solid ${COLORS.Orange};
`;

export const NotesBlock = styled(Box)`
  padding: 12px;
  background-color: ${COLORS.LightBlueBackground};
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.Black};
  white-space: pre-wrap;
`;

export const NoDataText = styled(Box)`
  color: ${COLORS.Gray};
  font-style: italic;
`;
